<template lang="pug">
    section
        ul.no-style-list
            li(v-for="(address, index) in addresses")
                Address(
                    :index="index"
                    :data="address"
                    :show-default-switches="showDefaultSwitches"
                )
                el-button.restore-address(
                    v-if="address.deleted"
                    circle type="success" size="mini"
                    icon="el-icon-fa-trash-restore fas"
                    @click.prevent.stop="restoreAddress(index)"
                )
                el-button.delete-address(
                    v-else-if="isDeletable(address)"
                    circle type="info" size="mini"
                    icon="el-icon-fa-trash-alt far"
                    @click.prevent.stop="deleteAddress(index)"
                )
                hr.wave(v-if="index !== addresses.length - 1")
        el-button(type="primary" icon="el-icon-fa-plus fas" @click="addAddress") {{ $t('Add Address') }}
</template>

<i18n>
{
  "de": {
    "Add Address": "Addresse hinzufügen"
  }
}
</i18n>

<script>

import { useSetupStore, useRestrictedAreaMemberStore } from '@/stores'

import Address from './Partials/Address'

export default {
    name: 'Addresses',
    components: {
        Address,
    },
    watch: {
        addresses() {
            this.$nextTick(this.fixRequiredShippingAndBillingAddress)
        }
    },
    computed: {
        showDefaultSwitches() {
            return this.addresses.length > 1 && this.enabledExtensions.includes('shop')
        },
        setupStore() {
            return useSetupStore()
        },
        memberStore() {
            return useRestrictedAreaMemberStore()
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions
        },
        addresses() {
            return this.memberStore.formAddresses
        }
    },
    methods: {
        isDeletable(address) {
            return ! address.default_billing && ! address.default_shipping
        },
        deleteAddress(index) {
            this.memberStore.markFormAddressAsDeleted(index)
        },
        restoreAddress(index) {
            this.memberStore.unmarkFormAddressAsDeleted(index)
        },
        addAddress() {
            this.memberStore.addFormAddress()
        },
        fixRequiredShippingAndBillingAddress() {
            // check if there is only on address
            // if so, make it default_billing and default_shipping
            // also check if there is no address and add one

            if (this.enabledExtensions.includes('shop')) {
                if (! this.addresses || ! this.addresses.length) {
                    this.addAddress();
                } else if (this.addresses.length === 1) {
                    const i = 0
                    const value = true

                    this.memberStore.setFormDefaultBilling({ i, value })
                    this.memberStore.setFormDefaultShipping({ i, value })
                }
            }
        },
    },
    mounted() {
        this.fixRequiredShippingAndBillingAddress();
    }
}
</script>

<style lang="sass" scoped>
li
    position: relative
    .delete-address, .restore-address
        position: absolute
        top: 10px
        right: 10px
    & + li
        margin-top: 40px
        .delete-address, .restore-address
            top: 10px
</style>
